import type React from 'react';
import styles from './RouteDirectoryStyles';

interface RouteItem {
  label: string;
  path?: string;
}

interface RouteDirectoryProps {
  routes?: RouteItem[];
}

export default function RouteDirectory({ routes = [] }: RouteDirectoryProps): React.ReactElement {
  const classes = styles();
  return (
    <div className={classes.routesContainer}>
      {routes.map(({ label, path }, indx) => (
        <div
          key={`${label}-${path ?? indx}`}
          className={indx !== routes.length - 1 ? classes.prevRoutes : classes.activeRoute}
        >
          {label}
          {indx !== routes.length - 1 && ' > '}
        </div>
      ))}
    </div>
  );
}
